<template>
  <div
    class="swiper-slide"
    style="width: 302px !important; padding: 0 8px;">
    <div class="payment-unit">
      <a class="payment-link">
        <div class="payment-card" :class="account.style">
          <span class="icon"></span>
          <span class="txt">{{ account.bank }}</span>
          <span class="name">{{ ownerName }}</span>
          <span
            class="account_number">
            {{ account.accountNumber }}
          </span>
        </div>
      </a>
    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: "AccountSlider",
  props: {
    account: {
      type: Object,
      required: true,
      default: () => {
        return {
          accountNumber: "1111****1111",
          bank: "KB국민은행",
          customerId: "1234567",
          id: "b_asdlkj2D3laskdj",
          methodKey: "b298830nfklsndfo10eruowedkfsfc",
          registeredAt: "Wed Mar 16 15:22:48 KST 2022",
          status: true,
        }
      }
    },
  },
  methods: {

  },
  computed: {
    ...mapGetters({
      selectedParty: "amwaypay/selectedParty",
      masterName: "amwaypay/currentMasterName",
      subName: "amwaypay/currentSubName",
    }),
    ownerName() {
      return this.selectedParty === 0 ? this.masterName : this.subName;
    },
  }
}
</script>

<style scoped>

</style>
